angular.module('qkr').controller("unknownFinance1EmailConfigController",
    unknownFinance1EmailConfigController);

unknownFinance1EmailConfigController.$inject = ['$uibModalInstance', 'messageService', 'lookupDataUploadService',
    'reportService', 'data', 'gettextCatalog'];

    function unknownFinance1EmailConfigController ($uibModalInstance, messageService, lookupDataUploadService,
                                                      reportService, data, gettextCatalog) {
        const vm = this;
        vm.hours = reportService.getHours();
        vm.minutes = reportService.getMinutes();
        vm.form = data;
        vm.finance1NonMatchedSetting = {};

        vm.cancel = () => {
            $uibModalInstance.close(false);
        };

        vm.addFinance1NonMatchedEmail = () => {
            // Gets ride of validation warning
            if (vm.form.errors && vm.form.errors.email) {
                vm.form.errors.email = '';
            }
            if (vm.form.emailList.indexOf(vm.finance1NonMatchedSetting.email) ===-1) {
                vm.form.emailList.push(vm.finance1NonMatchedSetting.email);
            }
            vm.finance1NonMatchedSetting.email = '';
        };

        vm.removeFinance1NonMatchedEmail = (index) => {
            vm.form.emailList.splice(index, 1);
        };

        vm.save = () => {
            if (!validateEmail()) {
                return;
            }
            lookupDataUploadService.saveUnknownLookupFinance1EmailConfig(vm.form).then((response) => {
                if (response.status === 200){
                    $uibModalInstance.close("Saved");
                    messageService.success(gettextCatalog.getString('Email details saved'));
                }
            }).catch(reason => {
                messageService.errorWithReason(reason, 'update failed', true);
            });
        };

        function validateEmail() {
            // Empty the errors list
            vm.errors = null;
            let valid = true;
            const errors = {};

            // Check at least 1 email is added
            if (vm.form.emailList.length <= 0) {
                errors.email = gettextCatalog.getString('At least 1 email address is required');
                valid = false;
            }
            vm.form.errors = errors;
            return valid;
        }
    }




// WEBPACK FOOTER //
// ./src/controllers/unknownFinance1.email.config.controller.js